// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.resource-editor-panel {
    position: relative;
    height: 100%;
}

.resource-editor-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: var(--color-overlay-back);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0.5rem;
    z-index: 1;
}

.resource-editor-overlay-content {
    width: 100%;
    height: 100%;
    text-align: center;
    color: var(--color-overlay-fore);
}

    .resource-editor-overlay-content > .spinner-border {
        color: var(--color-overlay-fore);
    }

.resource-editor-overlay-text {
    margin-top: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/Data/DataDisplay/css/ResourceEditorPanel.css"],"names":[],"mappings":"AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,qCAAqC;IACrC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;AACpC;;IAEI;QACI,gCAAgC;IACpC;;AAEJ;IACI,gBAAgB;AACpB","sourcesContent":["@import '../../../css/App.css';\r\n\r\n.resource-editor-panel {\r\n    position: relative;\r\n    height: 100%;\r\n}\r\n\r\n.resource-editor-overlay {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background: var(--color-overlay-back);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    border-radius: 0.5rem;\r\n    z-index: 1;\r\n}\r\n\r\n.resource-editor-overlay-content {\r\n    width: 100%;\r\n    height: 100%;\r\n    text-align: center;\r\n    color: var(--color-overlay-fore);\r\n}\r\n\r\n    .resource-editor-overlay-content > .spinner-border {\r\n        color: var(--color-overlay-fore);\r\n    }\r\n\r\n.resource-editor-overlay-text {\r\n    margin-top: 10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
